export const APPRAISAL_TARGET_METRICS = Object.freeze([
  { id: 'roce', label: 'ROCE' },
  { id: 'profit_on_gdv', label: 'Profit on GDV' },
  { id: 'profit_on_gdc', label: 'Profit on GDC' },
])

const TARGET_ALIASES = new Map([
  ['roce', 'roce'],
  ['profit_on_gdv', 'profit_on_gdv'],
  ['profit on gdv', 'profit_on_gdv'],
  ['profit_on_gdc', 'profit_on_gdc'],
  ['profit on gdc', 'profit_on_gdc'],
])

export function normalizeTargetMetric(value) {
  const key = String(value ?? '').trim().toLowerCase()
  if (!key) return 'roce'

  return TARGET_ALIASES.get(key) ?? null
}

export function targetMetricLabel(value) {
  const metric = normalizeTargetMetric(value)

  return APPRAISAL_TARGET_METRICS.find((option) => option.id === metric)?.label ?? 'Unsupported target'
}

export function targetReturnError(metric, value) {
  const normalizedMetric = normalizeTargetMetric(metric)
  if (!normalizedMetric) return 'Select a supported target metric.'

  const rawValue = String(value ?? '').trim()
  if (!rawValue) return 'Enter a target return.'

  const percentage = Number(rawValue.replace(/[%\s,]/g, ''))
  if (!Number.isFinite(percentage)) return 'Enter a valid target return.'
  if (percentage <= 0) return 'Target return must be greater than 0%.'
  if (normalizedMetric === 'profit_on_gdv' && percentage >= 100) {
    return 'Profit on GDV target must be below 100%.'
  }

  return ''
}
